import createStore from './store';
import { ClipAvailabilityStatus } from '@/player-config/src/types/clip-availability';

export const clipAvailabilityStatus = createStore<Record<string, ClipAvailabilityStatus>>({});

export const updateClipAvailabilityStatus = (clipId: string, status: ClipAvailabilityStatus) => {
  // eslint-disable-next-line no-console
  console.log(status);
  clipAvailabilityStatus.update(prevState => ({ ...prevState, [clipId]: status }));
};
